import React from 'react';

// eslint-disable-next-line max-len
const FREEFOLK = '/themes/theme/freefolk/logo.png';
const FREEFOLK_DARK_LOGO = '/themes/theme/freefolk/logo.png';

const FreefolkTheme = {
  headerLogo: {
    src: FREEFOLK,
    alt: 'Free Folk Logo',
    size: 80,
  },
  darkLogo: {
    src: FREEFOLK_DARK_LOGO,
    alt: 'Free Folk Logo',
    size: 80,
  },
  linkStyle: {
    color: '#37AAFA',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #37AAFA',
    height: 100,
  },
  title: 'Free Folk',
  isLightOnDark: false,
  organisationId: '6b36442f-d960-45c0-97a9-b12b4be626ea',
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="80"
        src={FREEFOLK_DARK_LOGO} alt="Free Folk Logo"
      />
      <br /><br />
      {/* <h3>Free Folk</h3> */}
    </div>
  ),
  shareSite: 'https://share.freefolkagency.com',
};

export default FreefolkTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/freefolk.js
 **/